<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Experience</h2>

  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-6">
      <!-- timeline wrapper -->
      <div class="timeline edu rounded bg-white shadow-dark padding-30 overflow-hidden">
        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp">
          <div class="content">
            <span class="time">2021 - 2023</span>
            <h3 class="title">Master of Information Technology</h3>
            <p>FEDERAL GOVERNMENT VIRTUAL
              UNIVERSITY OF PAKISTAN.</p>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.2s">
          <div class="content">
            <span class="time">2018 - 2020</span>
            <h3 class="title"> B.SC Bachelor of Science</h3>
            <p>PUNJAB UNIVERSITY</p>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.4s">
          <div class="content">
            <span class="time">2015 - 2017</span>
            <h3 class="title">Intermediate of Computer Science</h3>
            <p>SUPIRIOR COLLEGE KHARIAN</p>
          </div>
        </div>

        <!-- main line -->
        <span class="line"></span>
      </div>
    </div>

    <div class="col-md-6">
      <!-- responsive spacer -->
      <div class="spacer-30 d-md-none d-lg-none"></div>

      <!-- timeline wrapper -->
      <div class="timeline exp bg-white shadow-dark rounded padding-30 overflow-hidden">
        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp">
          <div class="content">
            <span class="time">2023 - Present</span>
            <h3 class="title">Front-End Developer</h3>
            <p>I am a front-end developer at NCU Technologies, specializing in Angular, where I leverage my skills to create dynamic and responsive web applications for enhanced user interactions.</p>
          </div>
        </div>

        <!-- timeline item -->
        <div class="timeline-container wow fadeInUp" data-wow-delay="0.2s">
          <div class="content">
            <span class="time">2017 - 2018</span>
            <h3 class="title">DATA ENTRY SPECIALIST</h3>
            <p>Responsible for managing and processing travel-
              related data.
              Tasks included accurate entry and updates of
              travel itineraries, client information, and bookings.</p>
          </div>
        </div>

        <!-- timeline item -->
        <!-- <div class="timeline-container wow fadeInUp" data-wow-delay="0.4s">
          <div class="content">
            <span class="time">2013 - 2009</span>
            <h3 class="title">Back-End Developer</h3>
            <p>Lorem ipsum dolor sit amet quo ei simul congue exerci ad nec admodum perfecto.</p>
          </div>
        </div> -->

        <!-- main line -->
        <span class="line"></span>
      </div>
    </div>
  </div>
</div>
